
import { defineComponent } from 'vue'
import { handleAxiosException } from '@/api'
import { userApi } from '@/api/user'
import snackbarStore from '@/store/snackbarStore'
import SwitchLocale from '@/components/SwitchLocale.vue'

export default defineComponent({
  name: 'AccountTriggerActivationMail',
  components: {
    SwitchLocale,
  },
  props: {
    email: {
      required: true,
      type: String,
    },
  },
  data: () => ({
    sent: false,
    sending: false,
  }),
  methods: {
    async sendMail() {
      try {
        this.sending = true
        if (this.email) {
          await userApi.sendAccountValidationEmail(this.email)
          this.sent = true
        } else {
          this.$router.push({ name: 'Login' })
        }
      } catch (err) {
        snackbarStore.setError(this.$t(handleAxiosException(err)) as string)
      } finally {
        this.sending = false
      }
    },
    isTrot(): boolean {
      return !!process.env.VUE_APP_IS_TROT
    },
  },
  mounted() {
    this.sendMail()
  },

})
